import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { PublishedStatus } from "_graphql/__generated__/globalTypes-kek";
import { Offers_rows } from "_graphql/visal/queries/__generated__/Offers";
import clsx from "clsx";
import numeral from "numeral";
import { extractVehicleNumberFromDetails } from "utils";
import { TableColumn, TColumn } from "utils/types";

export const columns: TableColumn<TColumn<Offers_rows>> = [
  {
    name: "Policy #",
    accessor: "offer_detail.policy_number",
    render: (value) => (
      <div className="flex flex-col items-start flex-wrap break-all break-words">
        <div className="flex flex-row items-center gap-x-1">
          {value?.offer_published &&
            value?.offer_published?.published_status ===
              PublishedStatus.PUBLISHED && (
              <CheckBadgeIcon
                className={clsx("w-4 h-4 mr-1", "text-green-600")}
              />
            )}
          <span className="font-bold text-xs overflow-hidden text-ellipsis  ">
            {value.offer_detail?.policy_number || "N/A"}
          </span>
        </div>
        <div
          className={clsx(
            "p-0.5 rounded-full",
            {
              " text-green-600": value.offer_from === "INTERNAL",
              " text-yellow-600": value.offer_from !== "INTERNAL",
            },
            "text-xs font-medium"
          )}
        >
          <span>{value.offer_from}</span>
        </div>
      </div>
    ),
  },
  {
    name: "Insurance Company",
    accessor: "insurer.insurer_company_name",
    render: (value) => (
      <div className="flex flex-col text-xs">
        <span className="font-medium">
          {value.insurer?.insurer_company_name || "N/A"}
        </span>
        <span className="font-light">
          {value.insurer?.insurer_company_email || "N/A"}
        </span>
      </div>
    ),
  },
  {
    name: "Insured",
    accessor: "offer_detail.insured_by",
    render: (value) => {
      const details = JSON.parse(value?.offer_detail?.offer_details || "[]");
      return (
        <div className="flex flex-col text-xs ">
          <span className="font-medium">
            {value.offer_detail?.insured_by || "N/A"}
          </span>
          <span className="font-light">
            {[
              "Motor Comprehensive Fleet",
              "Motor Comprehensive",
              "Motor Comprehensive (Automobile Fac Facility)",
            ].includes(value?.classofbusiness?.business_name || "")
              ? extractVehicleNumberFromDetails(details)
              : ""}
          </span>
        </div>
      );
    },
  },
  {
    name: "Class Of Business",
    accessor: "classofbusiness.business_name",
    render: (value) => (
      <div className="flex flex-col text-xs">
        <span className="font-medium">
          {value.classofbusiness?.business_name || "N/A"}
        </span>
      </div>
    ),
  },
  {
    name: "Sum Insured",
    accessor: "sum_insured",
    render: (value) => (
      <div className="flex flex-col text-xs">
        <span className="font-medium">
          {value?.offer_detail?.currency}{" "}
          {numeral(value.sum_insured).format("0,0 ") || "N/A"}
        </span>
      </div>
    ),
  },
  {
    name: "Premium",
    accessor: "premium",
    render: (value) => (
      <div className="flex flex-col text-xs">
        <span className="font-medium">
          {value?.offer_detail?.currency}{" "}
          {numeral(value.premium).format("0,0 ") || "N/A"}
        </span>
      </div>
    ),
  },
  {
    name: "Offer Date",
    accessor: "created_at",
    render: (value) => new Date(value.created_at).toLocaleDateString(),
  },
  {
    name: "Expiry Status",
    accessor: "expiry_status",
    render: (value) => (
      <div className="flex flex-col items-start">
        <div
          className={clsx(
            "p-1 rounded-lg",
            {
              "bg-green-600/30 text-green-600":
                value.expiry_status === "ACTIVE",
              "bg-red-50/30 text-red-600": value.expiry_status === "EXPIRED",
            },
            "text-xs font-medium"
          )}
        >
          <span>{value.expiry_status}</span>
        </div>
      </div>
    ),
  },
  {
    name: "Payment Status",
    accessor: "payment_status",
    render: (value) => (
      <div className="flex">
        <div
          className={clsx(
            "p-1 rounded-lg",
            {
              "bg-green-600/30 text-green-600": value.payment_status === "PAID",
              "bg-red-300/30 text-red-600": value.payment_status === "UNPAID",
              "bg-sky-600/30 text-sky-600":
                value.payment_status === "PARTPAYMENT",
            },
            "text-xs font-medium"
          )}
        >
          <span>{value.payment_status}</span>
        </div>
      </div>
    ),
  },
  {
    name: "Created By",
    accessor: "employee.employee_first_name",
    render: (value) => (
      <div className="flex flex-row leading-0">
        <span>
          {value?.employee?.employee_first_name}{" "}
          {value?.employee?.employee_last_name}
        </span>
      </div>
    ),
  },
];
